module.exports = __webpack_public_path__ + "static/media/logo.81895730.webp";